var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenants({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_821_15703)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.763 1.07488C14.8354 1.11968 14.8952 1.18223 14.9367 1.25661C14.9782 1.33098 15 1.41472 15 1.49988V16.4999C15 16.6325 14.9473 16.7597 14.8536 16.8534C14.7598 16.9472 14.6326 16.9999 14.5 16.9999H11.5C11.3674 16.9999 11.2402 16.9472 11.1464 16.8534C11.0527 16.7597 11 16.6325 11 16.4999V14.9999H10V16.4999C10 16.6325 9.94732 16.7597 9.85355 16.8534C9.75979 16.9472 9.63261 16.9999 9.5 16.9999H0.5C0.367392 16.9999 0.240215 16.9472 0.146447 16.8534C0.0526784 16.7597 0 16.6325 0 16.4999V10.9999C7.96467e-05 10.895 0.0331481 10.7928 0.0945249 10.7077C0.155902 10.6226 0.242478 10.559 0.342 10.5259L6 8.63988V5.49988C6 5.4071 6.02582 5.31616 6.07456 5.23721C6.12331 5.15827 6.19305 5.09445 6.276 5.05288L14.276 1.05288C14.3523 1.01469 14.4371 0.996659 14.5224 1.00051C14.6076 1.00436 14.6904 1.02996 14.763 1.07488ZM6 9.69388L1 11.3599V15.9999H6V9.69388ZM7 15.9999H9V14.4999C9 14.3673 9.05268 14.2401 9.14645 14.1463C9.24021 14.0526 9.36739 13.9999 9.5 13.9999H11.5C11.6326 13.9999 11.7598 14.0526 11.8536 14.1463C11.9473 14.2401 12 14.3673 12 14.4999V15.9999H14V2.30888L7 5.80888V15.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12H3V13H2V12ZM4 12H5V13H4V12ZM2 14H3V15H2V14ZM4 14H5V15H4V14ZM8 10H9V11H8V10ZM10 10H11V11H10V10ZM8 12H9V13H8V12ZM10 12H11V13H10V12ZM12 10H13V11H12V10ZM12 12H13V13H12V12ZM8 8H9V9H8V8ZM10 8H11V9H10V8ZM12 8H13V9H12V8ZM8 6H9V7H8V6ZM10 6H11V7H10V6ZM12 6H13V7H12V6ZM12 4H13V5H12V4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_821_15703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenants);
export default __webpack_public_path__ + "static/media/tenants.37a646e127bf113bb68045be70412ebc.svg";
export { ForwardRef as ReactComponent };